import { Fragment, useState, useCallback, useEffect, useRef } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
  MarkerClusterer,
} from "@react-google-maps/api";
import purple_mark from "./../../../assets/icons/Map/purple_mark_icon.svg";
import yellow_mark from "./../../../assets/icons/Map/yellow_mark_icon.svg";
import blue_mark from "./../../../assets/icons/Map/blue_mark_icon.svg";
import light_blue_mark from "./../../../assets/icons/Map/light_blue_mark_icon.svg";
import classes from "./MapPOIS.module.css";
import "./mapsCss.css";

import * as Icon from "../../Map/smartiscity/Icons";

import { useStore } from "../../../hooks/store";
import BoxTitle from "../../box/title/BoxTitle";
import { LoadingCircle } from "../../UI/spinners/LoadingSpinners";
import { useAllContexts } from "../../../hooks/useAllContexts";
import { getMapStyles, getMarkerIcon } from "../../Map/helpers";

const options = {
  imagePath:
    "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
};
const libraries = ["visualization", "places"];

const MapPOIS = (props) => {
  const { ameaInfrastructures, allSensors, bins, hotSpots, fleet, hydro } =
    useAllContexts();

  const getCityCenter = () => {
    switch (props.cityName) {
      case "dimokritos": {
        return {
          lat: 37.999341,
          lng: 23.819618,
        };
      }
      case "skoufas": {
        return {
          lat: 39.082936,
          lng: 21.050986,
        };
      }
      case "korydallos": {
        return {
          lat: 37.980395,
          lng: 23.648577,
        };
      }
      default: {
        return {
          lat: 40.653582,
          lng: 22.922504,
        };
      }
    }
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDQlCnn8F1D0S9ymnWZwc_WFx2ZS6g8w1Q",
    // ...otherOptions
  });
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [infoWindowData, setInfoWindowData] = useState(null);
  const state = useStore()[0];
  const typeRef = useRef(null);
  const mapStyleRef = useRef(null);
  const [cityCenter, setCityCenter] = useState(getCityCenter());
  // const centerMapRef = useRef(cityCenter);

  useEffect(() => {
    if (state.types.length > 0) {
      for (let y = 0; y < state.types.length; y++) {
        if (state.types[y].id === props.typeId) {
          typeRef.current = state.types[y];
          break;
        }
      }
    }
  }, [state.types]);

  useEffect(() => {
    switch (props.typeId) {
      case "122":
        if (ameaInfrastructures.infrastructureData) {
          setMarkers(ameaInfrastructures.infrastructureData);
        }
        break;
      case "32":
        if (allSensors?.allSensorsData) {
          if (allSensors?.allSensorsData[32]?.data) {
            setMarkers(allSensors?.allSensorsData[32]?.data);
          } else {
            setMarkers([]);
          }
        }
        break;
      case "31":
        if (allSensors?.allSensorsData) {
          console.log("allSensors 31", allSensors?.allSensorsData[31]?.data);
          if (allSensors?.allSensorsData[31]?.data) {
            setMarkers(allSensors?.allSensorsData[31]?.data);
          } else {
            setMarkers([]);
          }
        }
        break;
      case "4":
        if (allSensors.allSensorsData) {
          setMarkers(allSensors?.allSensorsData[4]);
        } else {
          setMarkers([]);
        }
        break;
      case "7":
        if (allSensors.allSensorsData) {
          setMarkers(allSensors?.allSensorsData[7]);
        } else {
          setMarkers([]);
        }
        break;
      case "8":
        if (fleet?.fleetData) {
          setMarkers(fleet.fleetData);
        } else {
          setMarkers([]);
        }
        break;
      case "9":
        // console.log("bins", bins);
        if (bins.binsData) {
          setMarkers(bins.binsData);
        } else {
          setMarkers([]);
        }
        break;
      case "10":
        if (hydro.hydroData) {
          setMarkers(hydro.hydroData);
        } else {
          setMarkers([]);
        }
        break;
      case "30":
        if (allSensors.allSensorsData) {
          setMarkers(allSensors?.allSensorsData[30]);
        } else {
          setMarkers([]);
        }
        break;
      default:
        break;
    }
  }, [ameaInfrastructures, allSensors, bins, hotSpots, fleet, hydro]);

  useEffect(() => {
    mapStyleRef.current = getMapStyles(props.typeId);
  }, []);

  const onLoad = useCallback(function callback(map) {
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map) {
    setMap(map);
  }, []);

  const renderItems = () => {
    return null;
  };

  return (
    <Fragment>
      <BoxTitle
        className={classes.map_title_style}
        icon={
          props.typeId === "122"
            ? Icon.dAmea
            : props.typeId === "4"
            ? "im im-icon-Wifi"
            : props.typeId === "7"
            ? "im im-icon-Map-Marker"
            : props.typeId === "9"
            ? "im im-icon-Recycling"
            : props.typeId === "10"
            ? null
            : props.typeId === "30"
            ? "im im-icon-Battery-Charge"
            : typeRef.current && typeRef.current.icon
        }
        title={props.title}
        infoContext={typeRef.current && typeRef.current.tooltip}
        link={`/map?typeId=${props.typeId}`}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
        id={props.typeId}
      />

      {isLoaded && (
        <div className={classes.wrapper}>
          <GoogleMap
            center={{ lat: 40.576479, lng: 22.9587036 }}
            zoom={13}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
              styles: mapStyleRef?.current,
              zoomControl: false,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: false,
            }}
          >
            <MarkerClusterer options={options} averageCenter>
              {(clusterer) => {
                if (!markers || markers.length === 0) return [];
                const markerData = markers?.data ?? markers;
                console.log("markerData", markerData);
                return markerData?.map((marker, id) => {
                  return (
                    <Marker
                      key={
                        props.typeId === "122"
                          ? marker?.id
                          : props.typeId === "31" ||
                            props.typeId === "32" ||
                            props.typeId === "30"
                          ? marker?.mysensor_id
                          : `${props.typeId}_${
                              props.typeId === "4"
                                ? marker?.mysensor_id
                                : marker?.id
                            }`
                      }
                      position={
                        props.typeId === "122"
                          ? {
                              lat: marker?.latitude,
                              lng: marker?.longitude,
                            }
                          : props.typeId === "31" ||
                            props.typeId === "32" ||
                            props.typeId === "4" ||
                            props.typeId === "7" ||
                            props.typeId === "8" ||
                            props.typeId === "9" ||
                            props.typeId === "10" ||
                            props.typeId === "30"
                          ? {
                              lat: parseFloat(marker?.lat),
                              lng: parseFloat(marker?.lng),
                            }
                          : marker?.position
                      }
                      clickable
                      clusterer={clusterer}
                      icon={
                        props.typeId === "122"
                          ? getMarkerIcon(marker?.category)
                          : props.typeId === "4" ||
                            props.typeId === "7" ||
                            props.typeId === "8" ||
                            props.typeId === "9"
                          ? yellow_mark
                          : props.typeId === "30"
                          ? light_blue_mark
                          : purple_mark
                      }
                      onClick={() => {
                        setInfoWindowData(
                          props.typeId === "122"
                            ? marker?.id
                            : props.typeId === "31" || props.typeId === "32"
                            ? marker?.mysensor_id
                            : `${props.typeId}_${
                                props.typeId === "4" ||
                                props.typeId === "7" ||
                                props.typeId === "30"
                                  ? marker?.mysensor_id
                                  : marker?.id
                              }`,
                        );
                      }}
                      //
                    >
                      {infoWindowData &&
                        (((props.typeId === "31" ||
                          props.typeId === "32" ||
                          props.typeId === "4" ||
                          props.typeId === "7" ||
                          props.typeId === "30") &&
                          marker?.mysensor_id === infoWindowData) ||
                          ((props.typeId === "122" || props.typeId === "9") &&
                            marker?.id === infoWindowData)) && (
                          <InfoWindow>
                            <p style={{ whiteSpace: "pre-wrap" }}>
                              {props.typeId === "122"
                                ? marker?.title
                                : props.typeId === "31" || props.typeId === "32"
                                ? marker?.sensor_address
                                : props.typeId === "9"
                                ? `Κάδος: ${marker?.id}`
                                : props.typeId === "4"
                                ? `Wifi: ${marker?.mysensor_id}\n${
                                    marker?.metrics[0]?.value ?? ""
                                  }`
                                : ""}
                            </p>
                          </InfoWindow>
                        )}
                    </Marker>
                  );
                });
              }}
            </MarkerClusterer>
          </GoogleMap>
        </div>
      )}
      {!isLoaded && <LoadingCircle />}
    </Fragment>
  );
};

export default MapPOIS;
